module.exports = __webpack_public_path__ + "img/shop_dark.7ed995b6.webp";